import { FETCH_ALL_ADJUSTMENTS, FETCH_PAGINATE_ADJUSTMENTS, FETCH_CURRENT_ADJUSTMENT } from './../../mutation-types';

export default {
  [FETCH_ALL_ADJUSTMENTS](state, adjustments) {
    state.all = adjustments;
  },

  [FETCH_PAGINATE_ADJUSTMENTS](state, { adjustments, pagination }) {
    state.items = adjustments;
    state.pagination = pagination;
  },

  [FETCH_CURRENT_ADJUSTMENT](state, adjustment) {
    state.currentAdjustment = adjustment;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/adjustment/mutations.js